var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.03001 9.4C9.64784 9.4 11.77 7.29574 11.77 4.7C11.77 2.10426 9.64784 0 7.03001 0C4.41218 0 2.29001 2.10426 2.29001 4.7C2.29001 7.29574 4.41218 9.4 7.03001 9.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 20.0001C10.9126 20.0001 14.06 17.8958 14.06 15.3001C14.06 12.7044 10.9126 10.6001 7.03 10.6001C3.14744 10.6001 0 12.7044 0 15.3001C0 17.8958 3.14744 20.0001 7.03 20.0001Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.39 2.00006C13.8399 2.00069 13.2968 2.12366 12.8 2.36006C13.2191 3.37721 13.3549 4.4889 13.1929 5.57704C13.031 6.66517 12.5772 7.6891 11.88 8.54006C12.3324 8.95199 12.8784 9.24731 13.4708 9.4004C14.0631 9.55348 14.6839 9.55971 15.2792 9.41853C15.8745 9.27736 16.4263 8.99305 16.8869 8.59028C17.3474 8.1875 17.7027 7.67843 17.9219 7.10724C18.1411 6.53605 18.2177 5.91999 18.1449 5.31253C18.072 4.70506 17.8521 4.12454 17.5041 3.62134C17.1561 3.11813 16.6906 2.70745 16.1479 2.42492C15.6052 2.14239 15.0018 1.99655 14.39 2.00006Z",
    fill: "currentColor"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.39 10.5C13.829 10.4995 13.2694 10.5565 12.72 10.67C13.5461 11.1379 14.2394 11.8085 14.7345 12.6186C15.2296 13.4286 15.5103 14.3514 15.55 15.3C15.5456 16.2621 15.2568 17.2015 14.72 18C17.66 17.89 20 16.26 20 14.26C20 12.26 17.49 10.5 14.39 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.6bb0758a19ceb9a9a1555b90106a684b.svg";
export { ForwardRef as ReactComponent };